const ISLIVE = process.env.REACT_APP_IS_LIVE === '1'

export const BaseUrls: any = {
	API_SERVER: {
		url:ISLIVE ? process.env.REACT_APP_API_BASE_URL_LIVE : process.env.REACT_APP_API_BASE_URL_UAT
	},
}

export const S3_BASE_URL: any = ISLIVE ? process.env.REACT_APP_S3_BUCKET_URL_LIVE : process.env.REACT_APP_S3_BUCKET_URL_UAT;